import { T_SHIRT_SIZES } from './T_SHIRT_SIZES';
export var LABEL_SIZES = Object.freeze({
  md: T_SHIRT_SIZES.md,
  lg: T_SHIRT_SIZES.lg
});